import React from 'react';
import { Layout404 } from 'tt-ui-lib/core';

const FourOhFour = () => <Layout404 style={{ zIndex: 99999999 }} />;

export default FourOhFour;
